import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from "../../../authentication/services/authentication.service";
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {SlicePipe, UpperCasePipe} from '@angular/common';

@Component({
  selector: 'app-profile-circle',
  templateUrl: './profile-circle.component.html',
  styleUrls: ['./profile-circle.component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    UpperCasePipe,
    SlicePipe
  ]
})
export class ProfileCircleComponent implements OnInit {
  completeUserName = 'Username';

  constructor(
    public authenticationService: AuthenticationService,
    private router: Router,
    private translateService: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.completeUserName = localStorage.getItem("name") as string;
  }

  logout() {
    localStorage.clear();
    this.authenticationService.logout();
    this.router
      .navigate(['/login'])
      .catch(() => console.error('Rota não foi encontrada'));
  }
}
